module.exports = __webpack_public_path__ + "static/media/image-5.edfc1a6b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/depto-64/image-5.jpg
// module id = 266
// module chunks = 0